export default {
    get(api){
        return api.send.get('user');
    }
}
